import React from 'react'
import { Route, Redirect, withRouter, Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import ProjectContainer from './projects/ProjectContainer'
import ProjectPageContainer from './projects_project/ProjectPageContainer'
import ResourcePostContainer from './resource-posts/ResourcePostContainer'
import ResourcePostPageContainer from './resource-posts_post/ResourcePostPageContainer'
import NewResourcePostContainer from './resource-posts_new/NewResourcePostContainer'
import UserSettingsContainer from './user-settings/UserSettingsContainer'
import WorkloadContainer from './workload/WorkloadContainer'
import ManagerContainer from './manager/ManagerContainer'
import LoginContainer from './login/LoginContainer'
import NotificationContainer from './notifications/NotificationContainer'
import OrgChartContainer from './org-chart/OrgChartContainer'
import PublicationsContainer from './publications/PublicationsContainer'
import PublicationModal from './publications/components/PublicationModal'
import RequestPasswordReset from './login/components/RequestPasswordReset'
import ResetPassword from './login/components/ResetPassword'
import SAPResourcesContainer from './sap-resources/SAPResourcesContainer'
import SAPResourceShowPage from './sap-resources/components/SAPResourceShowPage'
import DataAccessRequest from "./data-access-request/DataAccessRequest";
import DataAccessRequestManager from "./data-access-request/DataAccessRequestManager";
import QMSTraining from './qms-training/QMSTraining'
import Assessment from './qms-training/QMSTraining/Assessment'
import Materials from './qms-training/QMSTraining/Materials'
import QMSTrainingManager from "./qms-training/QMSTrainingManager"
import Trainings from "./qms-training/QMSTraining/Trainings"
import SelectedTraining from './qms-training/QMSTraining/Trainings/SelectedTraining'
import LandingPage from './landing-page/LandingPage'
// import ProposalsContainer from './proposals/ProposalsContainer'
// import ProposalPageContainer from './proposals_proposal/ProposalPageContainer'
// import AnalyticsContainer from './analytics/AnalyticsContainer'
// import NewSAPResource from './sap-resources/components/NewSAPResource'


const RouteContainer = (props) => {
  return (
    <div>
      {/* <Route exact path="/" render={(routerProps) => {
        return localStorage.getItem("token") ? <Redirect to="/projects"/> : <LoginContainer routerProps={routerProps}/>
      }} /> */}

      <Route exact path="/" render={(routerProps) => {
        return localStorage.getItem("token") ? <LandingPage /> : <LoginContainer routerProps={routerProps}/>
      }} />

      <Route exact path="/reset-password" render={(routerProps) => {
        return <RequestPasswordReset routerProps={routerProps}/>
      }} />

      <Route exact path="/reset-password/:token_id/:token" render={(routerProps) => {
        return <ResetPassword routerProps={routerProps}/>
      }} />

      <Route exact path="/projects/:project" render={(routerProps) => {
        return localStorage.getItem("token") ? <Redirect to={`${routerProps.location.pathname}/project-overview`} /> : <Redirect to="/" />}}
      />

      <Route path="/projects/:project/updates" render={(routerProps) => {
          return localStorage.getItem("token") ? <ProjectPageContainer {...routerProps} type="updates" /> : <Redirect to="/" />}}
        />

      <Route path="/projects/:project/deliverables" render={(routerProps) => {
        return localStorage.getItem("token") ? <ProjectPageContainer {...routerProps} type="deliverables" /> : <Redirect to="/" />}}
      />

      <Route path="/projects/:project/project-overview" render={(routerProps) => {
        return localStorage.getItem("token") ? <ProjectPageContainer {...routerProps} type="project-overview" /> : <Redirect to="/" />}}
      />

      <Route path="/projects/:project/documentation" render={(routerProps) => {
        return localStorage.getItem("token") ? <ProjectPageContainer {...routerProps} type="documentation" /> : <Redirect to="/" />}}
      />

      <Route exact path="/manager" render={() => {
        return localStorage.getItem("token") ? <ManagerContainer /> : <Redirect to="/"/>
      }} />

      { props.currentUser.is_data_access_request_manager &&
        <Route exact path="/manager/data-access-request" render={() => {
          return localStorage.getItem("token") ? <DataAccessRequestManager /> : <Redirect to="/"/>
        }} />
      }

      { props.currentUser.is_qms_training_manager &&
        <Route exact path="/manager/qms-training/:tab?" render={() => {
          return localStorage.getItem("token") ? <QMSTrainingManager /> : <Redirect to="/"/>
        }} />
      }

      { props.currentUser.is_qms_training_manager &&
        <Route path="/manager/qms-training-assessment-preview/:assessmentId" render={(routerProps) => {
          return localStorage.getItem("token") ? <Assessment qmsRoute="/manager/qms-training/trainings" context="preview" /> : <Redirect to="/"/>
        }} />
      }

      <Route exact path="/data-access-request" render={() => {
        return localStorage.getItem("token") ? <DataAccessRequest /> : <Redirect to="/"/>
      }} />

      <Route exact path="/notifications" render={() => {
        return localStorage.getItem("token") ? <NotificationContainer /> : <Redirect to="/"/>
      }} />

      <Route exact path="/projects" render={(routerProps) => {
          return localStorage.getItem("token") ? <ProjectContainer {...routerProps} /> : <Redirect to="/"/>
        }} />

      <Route exact path="/resource-posts/:post" render={(routerProps) => {
        return localStorage.getItem("token") ? <ResourcePostPageContainer {...routerProps} /> : <Redirect to="/" />}
      } />
      <Route exact path="/resource-posts/new/post" render={(routerProps) => {
        return localStorage.getItem("token") ? <NewResourcePostContainer {...routerProps} /> : <Redirect to="/" />}
      } />
      <Route exact path="/resource-posts" render={(routerProps) => {
        return localStorage.getItem("token") ? <ResourcePostContainer {...routerProps}/> : <Redirect to="/"/>
      }} />
      {/*<Route exact path="/analytics" render={(routerProps) => {
        return localStorage.getItem("token") ? <AnalyticsContainer {...routerProps}/> : <Redirect to="/"/>
      }} />*/}
      <Route exact path="/user-settings" render={(routerProps) => {
        return localStorage.getItem("token") ? <UserSettingsContainer {...routerProps}/> : <Redirect to="/"/>
      }} />

      <Route path="/workload" render={(routerProps) => {
          return localStorage.getItem("token") ? <WorkloadContainer /> : <Redirect to="/"/>
        }} />

      <Route path="/qms-training/:id/assessment" render={(routerProps) => {
          return localStorage.getItem("token") ? <Assessment qmsRoute="/qms-training/" /> : <Redirect to="/"/>
        }} />

      <Route path="/qms-training/:id/materials" render={(routerProps) => {
          return localStorage.getItem("token") ? <Materials /> : <Redirect to="/"/>
        }} />

      <Route exact path="/qms-training/:id?" render={(routerProps) => {
          return localStorage.getItem("token") ? <QMSTraining /> : <Redirect to="/"/>
        }} />

      <Route exact path="/trainings" render={(routerProps) => {
          return localStorage.getItem("token") ? <Trainings /> : <Redirect to="/"/>
        }} />

      <Route exact path="/trainings/:id" render={(routerProps) => {
          return localStorage.getItem("token") ? <SelectedTraining /> : <Redirect to="/"/>
        }} />

      <Route path="/trainings/:id/assessment" render={(routerProps) => {
          return localStorage.getItem("token") ? <Assessment qmsRoute="/trainings/"  context="assessment" /> : <Redirect to="/"/>
        }} />

      <Route path="/org-chart" render={(routerProps) => {
          return localStorage.getItem("token") ? <OrgChartContainer /> : <Redirect to="/"/>
        }} />

      <Switch>
        <Route path="/publications" children={(routerProps) => <PublicationsContainer {...routerProps}/>} />
      </Switch>

      <Route exact path="/publications/:publication" children={(routerProps) => <PublicationModal {...routerProps} show={true}/>}/>

      <Switch>
        {/* <Route exact path="/sap-repository/new" render={(routerProps) => {
          return localStorage.getItem("token") ? <NewSAPResource {...routerProps} /> : <Redirect to="/" />
        }} /> */}
  
        <Route exact path="/sap-repository/:id" render={(routerProps) => {
          return localStorage.getItem("token") ? <SAPResourceShowPage {...routerProps} /> : <Redirect to="/" />
        }} />
  
        <Route exact path="/sap-repository" render={(routerProps) => {
          return localStorage.getItem("token") ? <SAPResourcesContainer {...routerProps} /> : <Redirect to="/" />
        }} />
      </Switch>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user
  }
}

export default withRouter(connect(mapStateToProps)(RouteContainer))



// WEBPACK FOOTER //
// ./src/routes/RouteContainer.js